import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import { CellObsProps } from './interfaces';
import {
  getMessagePercent,
  getMessageSupport,
  getMessageTimeRemain,
} from '../helpers';

const CellObs: React.FC<CellObsProps> = ({ simulation, strategyStatus }) => {
  const hasSimulationAndIsNotActive = simulation && !simulation.activated;

  const messagePercent = getMessagePercent(
    simulation?.executedPercent || 0,
    strategyStatus,
  );

  const messageTimeRemain = getMessageTimeRemain(
    simulation?.messageTimeRemain || '',
    strategyStatus,
  );

  const messageSupport = getMessageSupport(simulation?.activated);

  return (
    <Grid container direction="column">
      {hasSimulationAndIsNotActive ? (
        <>
          <Typography variant="subtitle2">{messageTimeRemain}</Typography>
          {simulation?.messageTimeRemain ? (
            <Typography variant="subtitle2">{messagePercent}</Typography>
          ) : null}
        </>
      ) : (
        <Typography variant="subtitle2">{messageSupport}</Typography>
      )}
    </Grid>
  );
};

export default CellObs;
